'use strict';

import React from 'react';
import { ObjFactory, PrmFactory } from 'rt-sd-common';
import { SgiMainComp } from 'rt-sd-comp';

class UIPreviewComp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uid: this.props.guid
        }
    }


    render = function () {


        var transferData = this.props.transferData;;
        var uid = this.props.guid;

        let ucvData = PrmFactory.getPrm(uid);
        if (!ucvData) return null;
        var objFct = new ObjFactory(uid);

        objFct.set('@currentObjFctUID', uid);

        for (const key in transferData) {
            objFct.set(key, transferData[key]);
        }

        return (
            <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                <SgiMainComp key={tool.uuid(8)} objFct={objFct} moduleDesc={ucvData}>
                </SgiMainComp>
            </div>
        )
    }

    //防止 走2遍
    shouldComponentUpdate() {
        // var params = this.props.location.query;
        // // POP 浏览器前进后退， PUSH 点击Link
        // tool.sgiLogger.info("this.props.location.action:" + this.props.location.action);
        // return this.props.location.action === "PUSH" || this.state.uuid == params.uuid;
        return this.state.uid != this.props.guid
    }
}

export { UIPreviewComp };



// WEBPACK FOOTER //
// ./apps/project/dev/UIPreviewComp.js